import { render, staticRenderFns } from "./RedirectToDiscountPopup.vue?vue&type=template&id=04a178a8&scoped=true&"
import script from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
export * from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedirectToDiscountPopup.vue?vue&type=style&index=0&id=04a178a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a178a8",
  null
  
)

export default component.exports